// client/src/components/agent/MessagePanel.jsx
import { useState } from 'react';
import { theme } from '../../theme';
import MessageThread from './MessageThread';
import MessageInput from './MessageInput';
import TransferModal from './TransferModal';
import CloseModal from './CloseModal';

export default function MessagePanel({ conv, messages, onSend, onTransfer, onTransferToFlow, onClose, onlineAgents, flows, typifications, token, isMobile, onBack, onOpenActions }) {
  const [menu, setMenu] = useState(false);
  const [modal, setModal] = useState(null); // 'transfer' | 'close'

  if (!conv) {
    return (
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: theme.colors.textMuted, fontSize: '0.95rem',
      }}>
        Selecciona una conversación para empezar
      </div>
    );
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {/* Header */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 16px', borderBottom: `1px solid ${theme.colors.border}`,
        background: theme.colors.surface,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
          {isMobile && (
            <button
              onClick={onBack}
              title="Volver"
              style={{
                background: 'transparent', border: `1px solid ${theme.colors.border}`,
                borderRadius: '6px', padding: '5px 10px', cursor: 'pointer',
                color: theme.colors.text, fontSize: '0.9rem', flexShrink: 0,
              }}
            >
              ←
            </button>
          )}
          <div style={{ minWidth: 0 }}>
            <div style={{ color: theme.colors.text, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📱 {conv.owner}</div>
            <div style={{ color: theme.colors.textMuted, fontSize: '0.75rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{conv.id}</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
        {isMobile && (
          <button
            onClick={onOpenActions}
            title="Acciones"
            style={{
              background: 'transparent', border: `1px solid ${theme.colors.border}`,
              borderRadius: '6px', padding: '5px 10px', cursor: 'pointer',
              color: theme.colors.text, fontSize: '0.95rem',
            }}
          >
            ⚙
          </button>
        )}
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setMenu((m) => !m)}
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              color: theme.colors.textMuted, fontSize: '1.3rem', padding: '4px 8px',
            }}
          >
            ⋮
          </button>
          {menu && (
            <div style={{
              position: 'absolute', right: 0, top: '110%', background: theme.colors.surface,
              border: `1px solid ${theme.colors.border}`, borderRadius: '8px',
              overflow: 'hidden', minWidth: '200px', zIndex: 50,
            }}>
              <button onClick={() => { setModal('transfer'); setMenu(false); }} style={{
                display: 'block', width: '100%', background: 'transparent', border: 'none',
                padding: '11px 16px', cursor: 'pointer', color: theme.colors.text,
                textAlign: 'left', fontSize: '0.88rem',
              }}>
                🔀 Transferir conversación
              </button>
              <button onClick={() => { setModal('close'); setMenu(false); }} style={{
                display: 'block', width: '100%', background: 'transparent', border: 'none',
                padding: '11px 16px', cursor: 'pointer', color: theme.colors.error,
                textAlign: 'left', fontSize: '0.88rem',
              }}>
                ✕ Cerrar conversación
              </button>
            </div>
          )}
        </div>
        </div>
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', background: theme.colors.background }}>
        <MessageThread messages={messages} />
      </div>

      {/* Input */}
      <MessageInput token={token} onSend={(payload) => onSend({ ...payload, conversation_id: conv.id })} />

      {/* Modals */}
      {modal === 'transfer' && (
        <TransferModal
          agents={onlineAgents}
          flows={flows || []}
          onTransfer={(toId) => { onTransfer(conv.id, toId); setModal(null); }}
          onTransferToFlow={(flowId) => { onTransferToFlow(conv.id, flowId); setModal(null); }}
          onClose={() => setModal(null)}
        />
      )}
      {modal === 'close' && (
        <CloseModal
          typifications={typifications}
          onSave={(typId, notas) => { onClose(conv.id, typId, notas); setModal(null); }}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}
